import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../common/modals/Modal';
import ModalHeader from '../common/modals/ModalHeader';
import ModalBody from '../common/modals/ModalBody';
import ModalForm from '../common/modals/ModalForm';
import ModalFooter from '../common/modals/ModalFooter';

import Checkbox from '@app/ui/sports-components/Checkbox';
import { Button, Row, Col, LoadingDots } from '@app/ui';
import classNames from '@app/ui/sports-components/utils/classNames';

import * as R from 'ramda';

const getIds = obj =>
    Object.entries(obj).reduce((arr, [key, val]) => {
        if (val) arr.push(key);
        return arr;
    }, []);

class PickSocialAccountsModal extends React.Component {
    state = {
        selected: {},
    };

    onToggleCheckbox = itemId =>
        this.setState(p => R.over(R.lensPath(['selected', itemId]), R.not, p));

    _onSubmit = e => {
        e.preventDefault();
        //Send to submission method
        const ids = getIds(this.state.selected);
        this.props.onSubmit(ids);
    };

    render() {
        const { onClose, items, linkedItems, title, emptyMsg, isSubmitting } =
            this.props;
        const { selected } = this.state;

        const selectedLength = Object.keys(selected).length;
        const disabled = selectedLength === 0;
        const avilableAccounts = Object.keys(items).filter(
            id => !linkedItems.includes(id),
        );
        const modalBodyClassnames = classNames('-overflow-scroll', {
            '-m-t-1': isSubmitting,
            '-m-b-1': isSubmitting,
        });

        return (
            <Modal>
                <ModalHeader title={title} onClose={onClose} />
                <ModalForm onSubmit={this._onSubmit}>
                    <ModalBody className={modalBodyClassnames}>
                        {isSubmitting ? (
                            <LoadingDots />
                        ) : (
                            <Row gutter={16}>
                                {avilableAccounts.length === 0 && (
                                    <div>{emptyMsg}</div>
                                )}
                                {Object.keys(items).map(platformUserId => {
                                    const account = items[platformUserId];
                                    const { name, profilePictureUrl } = account;

                                    const isLinkedAlready =
                                        linkedItems.includes(platformUserId);

                                    const _onToggle = () =>
                                        this.onToggleCheckbox(platformUserId);

                                    if (isLinkedAlready) return null;

                                    const isSelected =
                                        !!selected[platformUserId];

                                    return (
                                        <Col key={platformUserId} md={12}>
                                            <div className="gds-flex gds-flex--justify-start gds-flex--align-center -m-b-3">
                                                <div className="gds-form-group -m-b-1 -m-r-1">
                                                    <Checkbox
                                                        onClick={_onToggle}
                                                        checked={isSelected}
                                                        value={platformUserId}
                                                    />
                                                </div>
                                                <img
                                                    className="-inline-block -m-l-0 gds-circular-thumbnail gds-circular-thumbnail--sm -m-r-3"
                                                    src={profilePictureUrl}
                                                    alt={name}
                                                />
                                                <p
                                                    className="-ellipsis"
                                                    style={{
                                                        flex: '1',
                                                        minWidth: '0',
                                                    }}
                                                >
                                                    {name}
                                                </p>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            htmlType="submit"
                            size="small"
                            variant="primary"
                            className="-m-b-0"
                            disabled={disabled || isSubmitting}
                        >
                            Link Accounts
                        </Button>
                    </ModalFooter>
                </ModalForm>
            </Modal>
        );
    }
}

PickSocialAccountsModal.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    items: PropTypes.object.isRequired,
    linkedItems: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    emptyMsg: PropTypes.string.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
};

export default PickSocialAccountsModal;
